import type { FC } from "react";
import { NavLink } from "react-router-dom";
import { cn } from "../../utils/lib";

interface DashCardProps {
  Text: string;
  Content: string;
  OnClick?: () => void;
}

const DashCard: FC<DashCardProps> = ({ Text, Content, OnClick }) => {
  return (
    <div
      className="row-span-1 flex justify-between px-5 py-1.5 h-full border rounded-lg"
      onClick={OnClick}
    >
      <div
        className="flex flex-col justify-between py-2"
      >
        <span className="text-sm 2xl:text-lg font-normal text-gray-400">
          {Text}
        </span>
        <span className="text-2xl font-bold mt-1">{Content}</span>
      </div>
    </div>
  );
};

interface SideBarProps {
  Link: string;
  Icon: JSX.Element;
  Content: string;
  OnClick?: () => void;
  Active: boolean;
}

const SideBarIcon: FC<SideBarProps> = ({
  Link,
  Icon,
  Content,
  OnClick,
  Active,
}) => {
  return (
    <NavLink to={Link} onClick={OnClick} className="flex flex-col h-20 2xl:mt-3 items-center">
      <div className={cn("flex flex-col justify-between gap-1.5 px-2.5 w-full items-center ", Active ? "text-white" : "text-gray-300")}>
        <div
          className={cn(
            "inline-flex text-base 2xl:text-xl items-center justify-center p-1 ", Active ? "border bg-white rounded-md text-blue-600 " : "text-gray-300"
          )}
        >
          {Icon}
        </div>
        <div
          className={
            "text-xs 2xl:text-base "
          }
        >
          {Content}
        </div>
        <div
          className={cn("my-1  w-full border-b px-2  ", Active ? "border-white" : "border-gray-400")}
        />
      </div>
    </NavLink>
  );
};

export { DashCard, SideBarIcon };

